module.exports = __webpack_public_path__ + "static/media/zind_kanyinya2.06e17a2c.jpg";